import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Checkbox, Grid, TextField, CircularProgress, Pagination, Typography, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom';
import { TareaCard } from './TareaCard';
import { getClientes, getEstados, getOpcionesTareas, getTareas, getTodasTareas, getTrabajadores } from '../../../services/apis';
import SquareIcon from '@mui/icons-material/Square';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SearchIcon from '@mui/icons-material/Search';
import debounce from 'lodash.debounce';
import { useInterval } from 'react-use';

import { FormCrearTarea } from './FormCrearTarea';
import { ErrorYRedireccionar } from '../../../utils/componentes-utiles/ErrorYRedireccionar';
import { FormCrearSA } from './FormCrearSA';
import AutocompleteList from '../../../utils/componentes-utiles/AutocompleteList';
import { SubHeader } from '../../../utils/componentes-utiles/SubHeader';
import { OpcionesMenuFunc } from '../../../utils/componentes-utiles/OpcionesMenuFunc';
import { Error } from '../../../utils/componentes-utiles/Error';
import { use } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircleIcon from '@mui/icons-material/Circle';
import { FormCrearTipoTarea } from './FormCrearTipoTarea';
import EditIcon from '@mui/icons-material/Edit';
import { FormEditarTipoTarea } from './FormEditarTipoTarea';

export const TodasLasTareas = () => {
    const iconMapping = {
        AddCircleIcon: <AddCircleIcon />
    };
    const Navigate = useNavigate();
    const [contadorError, setContadorError] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [tareas, setTareas] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [estados, setEstados] = useState([]);
    const [crearTarea, setCrearTarea] = useState(false);
    const [crearSA, setCrearSA] = useState(false);
    const [opcionesTareas, setOpcionesTareas] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [opclientes, setOpClientes] = useState([]);
    const [opTrabajadores, setOpTrabajadores] = useState([]);
    const [opProyectos, setOpProyectos] = useState([]);
    const [proyectos, setProyectos] = useState([]);
    const [nombreProyecto, setNombreProyecto] = useState([]);
    const [timer, setTimer] = useState(null)
    const [trabajadorSelec, setTrabajadorSelec] = useState({ label: "Aginar a un Trabajador", value: "0" });
    const [clientesSelec, setClientesSelec] = useState({ label: "Aginar a un Trabajador", value: "0" });
    const [proyectoSelec, setProyectoSelec] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 100; // Máximo de artículos por página
    const [cargaFiltrados, setcargaFiltrados] = useState(false);
    const [totalTareas, setTotalTareas] = useState(0); // 👈 importante
    const [searchTerm, setSearchTerm] = useState('');
    const [tipoTarea, setTipoTarea] = useState({ label: 'Seleccione un Proyecto', value: "0" });
    const [opcionesTipoTareas, setOpcionesTipoTareas] = useState([]);
    const [tiposDeTarea, setTiposDeTarea] = useState([]);
    const [tiposTareaSelec, setTiposTareaSelec] = useState([]);
    const [openCrearTipos, setOpenCrearTipos] = useState(false);
    const [openEditarTipos, setOpenEditarTipos] = useState(false);
    const [idClientePreselec, setIdClientePreselec] = useState(null);
    const [idProyectoPreselec, setIdProyectoPreselec] = useState(null);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        handleScrollToTop();
    };
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Desplazamiento suave
        });
    }
    //filtros
    // Obtener la fecha actual y la fecha de hace 2 meses
    const today = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(today.getMonth() - 22);

    // Formatear las fechas en formato 'YYYY-MM-DD' (ISO)
    const formatDate = (date) => {
        return date.toISOString().split('T')[0];
    };

    const [filtros, setFiltros] = useState(
        {
            fechaDesde: formatDate(twoMonthsAgo),  // Fecha de hace 2 meses
            fechaHasta: formatDate(today),         // Fecha actual

        }
    );
    const filtrosRef = useRef(filtros);

    //utils
    const handleSearch = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
        setCurrentPage(1);

    };

    const debouncedHandleSearch = useCallback(debounce(handleSearch, 1000), []);

    useEffect(() => {
        if (Array.isArray(proyectoSelec) && proyectoSelec.length > 0) {
            // Toma el primer proyecto seleccionado
            setIdProyectoPreselec(proyectoSelec[0].value);
        } else {
            setIdProyectoPreselec(null); // o algún valor por defecto
        }
    }, [proyectoSelec]);

    useEffect(() => {
        if (Array.isArray(clientesSelec) && clientesSelec.length > 0) {
            setIdClientePreselec(clientesSelec[0].value); // Guarda el ID del primer cliente seleccionado
        } else {
            setIdClientePreselec(null); // O un valor por defecto
        }
    }, [clientesSelec]);


    const param = useParams();
    const paramRef = useRef(param);


    useEffect(() => {
        const tempFIl = filtrarTareas(estados, tareas, proyectos);
    }, [tareas]);


    useEffect(() => {
        // primeraCarga();
        cargarOpcionesTareas();
        cargarClientes();
        cargarTrabajadores();
        cargarEstados();

    }, []);

    useEffect(() => {
        setcargaFiltrados(false);
        filtrosRef.current = filtros;
        cargarTareas();
    }, [filtros, estados, currentPage, trabajadorSelec, clientesSelec, proyectoSelec, searchTerm, tiposDeTarea]);

    useEffect(() => {
        paramRef.current = param;
    }, [param]);

    // useEffect(() => {
    //     cargarTareas();
    // }, [trabajadorSelec, clientesSelec, proyectoSelec, searchTerm]);



    const iterarTiposTarea = (data) => {
        try {
            const tmp = [...data];
            const newTmp = [
                // Proyecto por defecto
                ...tmp.map((item) => ({
                    label: item.nombre,
                    value: item.id
                }))
            ];
            setOpcionesTipoTareas(newTmp);
            // console.log("Proyectos:", newTmp);
            let tipotareaseleccionado = newTmp.filter(opcion => data.id == opcion.value);
            // console.log("Tipo Tarea:", opcionesTipoTareas);

            setTipoTarea(tipotareaseleccionado[0]);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    const primeraCarga = async () => {
        let fechaDesde = filtros.fechaDesde;
        let fechaHasta = filtros.fechaHasta;
        try {
            const response = await getTodasTareas(param.id, 1, fechaDesde, fechaHasta);
            setTareas(response.data.tareas);
            setOpciones(response.data.opcionesTareas);
            setNombreProyecto(response.data.nombreProyecto[0].nombre)
            setContadorError(0)
            setTotalTareas(response.data.total)
            document.title = `(${tareas.length}) Tessa: ${response.data.nombreProyecto[0].nombre} Tareas`;


        } catch (error) {
            setContadorError(contadorError + 1);
            if (contadorError > 3) {
                console.error("Error cargar tareas:", error);
                localStorage.clear();
                Navigate("/login");
                document.cookie = "PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
        }

    }


    const cargarTareas = async () => {
        let fechaDesde = filtrosRef.current.fechaDesde;
        let fechaHasta = filtrosRef.current.fechaHasta;

        const estadosFiltroStr = estados
            .filter(estado => estado.checked == 1 || estado.checked == true)
            .map(estado => estado.id)
            .join(',');

        const tiposTareaFiltroStr = tiposDeTarea
            .filter(ttarea => ttarea.checked == 1 || ttarea.checked == true)
            .map(ttarea => ttarea.id)
            .join(',');

        const empleadosFiltro = Array.isArray(trabajadorSelec)
            ? trabajadorSelec.map(e => e.value).join(',')
            : trabajadorSelec?.value || '';

        const clientesFiltro = Array.isArray(clientesSelec)
            ? clientesSelec.map(c => c.value).join(',')
            : clientesSelec?.value || '';

        const proyectosFiltro = Array.isArray(proyectoSelec)
            ? proyectoSelec.map(p => p.value).join(',')
            : proyectoSelec?.value || '';

        try {
            const response = await getTodasTareas(
                0,
                1,
                fechaDesde,
                fechaHasta,
                estadosFiltroStr,
                itemsPerPage,
                currentPage,
                proyectosFiltro,
                empleadosFiltro,
                clientesFiltro,
                searchTerm,
                tiposTareaFiltroStr
            );

            setTareas(response.data.tareas);
            iterarProyectos(response.data.nombreProyecto);
            setTotalTareas(response.data.total);
            setContadorError(0);
            setcargaFiltrados(true);
            setLoaded(true);
            setOpciones(response.data.opcionesTareas);
            iterarTiposTarea(response.data.tipostarea);
            document.title = `(${response.data.total}) Tessa: ${response.data.nombreProyecto[0].nombre} Tareas`;

        } catch (error) {
            setContadorError(prev => prev + 1);
            if (contadorError > 3) {
                localStorage.clear();
                Navigate("/login");
                document.cookie = "PHPSESSID=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            }
        }
    };

    useInterval(cargarTareas, 30000);
    const cargarOpcionesTareas = async () => {
        try {
            const response = await getOpcionesTareas(0);
            setOpcionesTareas(response.data);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }


    const cargarEstados = async () => {
        try {
            const response = await getEstados();
            setEstados(response.data.estados);
            setTiposDeTarea(response.data.tipostarea);

        } catch (error) {
            console.error("Error al añadir el cliente:", error);
        }
    }
    const cargarClientes = async () => {
        try {
            const response = await getClientes();
            setClientes(response.data);
            const tmp = [...response.data];
            const newTmp = tmp.map((item, index) => ({
                label: item.nombre,
                value: item.id
            }))
            setOpClientes(newTmp);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    const cargarTrabajadores = async () => {
        try {
            const response = await getTrabajadores();
            const tmp = [...response.data];
            const newTmp = tmp.map((item, index) => ({
                label: item.nombre,
                value: item.id
            }))
            setOpTrabajadores(newTmp);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const iterarProyectos = (data) => {
        try {
            const tmp = [...data];
            const newTmp = [
                // Proyecto por defecto
                ...tmp.map((item) => ({
                    label: item.nombre,
                    value: item.id
                }))
            ];
            setOpProyectos(newTmp);
            console.log("Proyectos:", newTmp);

            // setProyectoSelec([{ label: 'Solicitudes Ayuda', value: 0 }]);
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const handleEvent = (opcionId) => {
        switch (opcionId) {
            case 1:
                setCrearTarea(true);

                // Lógica para la opción 1
                break;
            case 2:
                setCrearSA(true);
                break;

            default:
                console.log("Lógica para una opción desconocida ");

                // Lógica para una opción desconocida
                break;
        }
    }

    const handleChange = (event) => {

        const tareaNueva = { ...filtros, [event.target.name]: event.target.value };

        setFiltros(tareaNueva);
        if (event.target.name == ('fechaDesde' || 'fechaHasta')) {
            cargarEstados();
        }

    }

    const handleCheckboxChange = (id) => {
        const updatedEstados = estados.map((estado) =>
            estado.id === id ? { ...estado, checked: !estado.checked } : estado
        );

        setEstados(updatedEstados);

    };

    const handleRoundChange = (id) => {
        const updateTiposTarea = tiposDeTarea.map((tipotarea) =>
            tipotarea.id === id ? { ...tipotarea, checked: !tipotarea.checked } : tipotarea
        );

        setTiposDeTarea(updateTiposTarea);

    };



    //filtros Estados
    const filtrarTareas = (updatedEstados, tareas, proyectos) => {
        // setCurrentPage(1);

        // Obtener IDs de estados seleccionados
        const checkedEstadoIds = updatedEstados
            .filter(estado => estado.checked)
            .map(estado => estado.id);

        // Obtener IDs de proyectos seleccionados
        const checkedProyectosIds = proyectos
            .filter(proyecto => proyecto.checked)
            .map(proyecto => proyecto.id);

        // Filtrar tareas por estados
        let filteredTareas = tareas.filter(tarea =>
            checkedEstadoIds.includes(tarea.id_estado)
        );

        // Filtrar tareas por proyectos
        let tareasFiltradasPorProyecto = filteredTareas;
        if (Array.isArray(proyectoSelec) && proyectoSelec.length > 0) {
            tareasFiltradasPorProyecto = filteredTareas.filter(tarea =>
                proyectoSelec.some(selProyecto => selProyecto.value == tarea.id_proyecto)
            );
        }

        // Filtrar tareas por trabajadores seleccionados
        let tareasFiltradasPorTrabajadores = tareasFiltradasPorProyecto;
        if (trabajadorSelec.length > 0) {
            tareasFiltradasPorTrabajadores = filteredTareas.filter(tarea =>
                Array.isArray(tarea.trabajadores) && tarea.trabajadores.some(trabajador =>
                    Array.isArray(trabajadorSelec) &&
                    trabajadorSelec.some(selTrab => selTrab.value == trabajador.value)
                )
            );
        }

        // Filtrar tareas por clientes seleccionados
        let tareasFiltradasPorClientes = tareasFiltradasPorTrabajadores;
        if (clientesSelec.length > 0) {
            tareasFiltradasPorClientes = tareasFiltradasPorTrabajadores.filter(tarea =>
                clientesSelec.some(selCliente => selCliente.value == tarea.id_cliente)
            );
        }

        // Filtrar por término de búsqueda
        let tareasFiltradasSearchTerm = tareasFiltradasPorClientes;
        if (searchTerm.length > 1) {
            const propiedadesParaBuscar = ['asunto', 'descripcion', 'fecha', 'cliente', 'correo', 'trabajadores', 'id'];
            tareasFiltradasSearchTerm = tareasFiltradasPorClientes.filter(tarea =>
                propiedadesParaBuscar.some(propiedad => {
                    const valorProp = tarea[propiedad];
                    // Si es null o undefined, lo saltamos
                    if (valorProp == null) return false;
                    // Convertimos todo a string y bajamos a minúsculas
                    const texto = String(valorProp).toLowerCase();
                    return texto.includes(searchTerm.toLowerCase());
                })
            );
        }

        document.title = `(${tareasFiltradasSearchTerm.length}) Tessa: Tareas`;
        return tareasFiltradasSearchTerm;
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentTareas = tareas;
    return (
        <div className='fade-in-2 '>

            <SubHeader />
            {!loaded && (
                <CircularProgress size={40} />
            )}
            {(loaded && estados.length > 0 && opcionesTareas) && (
                <>

                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={12}
                        gap={1}
                    >
                        <Grid item xs={12}>
                            <Typography variant='h4' gutterBottom>
                                {nombreProyecto} {totalTareas} FEINES
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            xs={12}
                        >
                            <OpcionesMenuFunc handleEvent={handleEvent} opciones={opcionesTareas} />

                        </Grid>

                    </Grid>
                    <div className="flex-center">

                        <Grid container gap={2} maxWidth={"90%"} direction="row" justifyContent="center" alignItems="center"  >
                            {/* <h1>{tareas.length > 0 ? '' : <ErrorYRedireccionar mensaje={'No tienes acceso a este Proyecto'} />}</h1> */}

                            {estados.length > 0 && (
                                <> {/* filtros */}
                                    { }
                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="center"
                                        alignItems="center"
                                        xs={12}
                                    >
                                        <Grid
                                            container
                                            direction="row"
                                            justifyContent="center"
                                            alignItems="center"
                                            xs={12}
                                            sx={{ mt: 2, mb: 2 }}
                                        >
                                            <Pagination
                                                count={Math.ceil(totalTareas / itemsPerPage)}
                                                page={currentPage}
                                                siblingCount={0}
                                                onChange={handlePageChange}
                                                color="primary"
                                            />
                                        </Grid>
                                        <Accordion sx={{ width: '100%' }} defaultExpanded>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1-content"
                                                id="panel1-header"
                                            >
                                                <Typography component="span">Filtros y Estados</Typography>
                                            </AccordionSummary>

                                            <AccordionDetails>

                                                {/* Grid de filtros */}
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="space-around"
                                                    alignItems="end"
                                                    xs={12}
                                                    gap={1}
                                                >
                                                    <Grid item xs={5} sm={5} md={1.5} lg={1} xl={1}>
                                                        <TextField
                                                            fullWidth
                                                            label="Fecha Desde"
                                                            type="date"
                                                            name="fechaDesde"
                                                            value={filtros.fechaDesde || new Date().toISOString().split('T')[0]}
                                                            onChange={handleChange}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={5} sm={5} md={1.5} lg={1} xl={1}>
                                                        <TextField
                                                            fullWidth
                                                            label="Fecha Hasta"
                                                            type="date"
                                                            name="fechaHasta"
                                                            value={filtros.fechaHasta || new Date().toISOString().split('T')[0]}
                                                            onChange={handleChange}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={11} sm={5} md={4} lg={3} xl={2}>
                                                        <AutocompleteList array={opTrabajadores} setArray={setTrabajadorSelec} label={"Asignados"} />
                                                    </Grid>

                                                    <Grid item xs={11} sm={5} md={4} lg={3} xl={2}>
                                                        <AutocompleteList array={opclientes} setArray={setClientesSelec} label={"Clientes"} />
                                                    </Grid>

                                                    <Grid item xs={11} sm={5} md={4} lg={3} xl={2}>
                                                        <AutocompleteList array={opProyectos} setArray={setProyectoSelec} label={"Proyectos"} arrayPre={proyectoSelec} />
                                                    </Grid>

                                                    <Grid item xs={11} sm={12} md={12} lg={2.5} xl={3}>
                                                        <TextField
                                                            onChange={debouncedHandleSearch}
                                                            label="Buscar"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>

                                                {/* Leyenda de estados */}
                                                <Grid
                                                    container
                                                    xs={12}
                                                    direction="column"
                                                    alignItems="center"
                                                    fontWeight={700}
                                                    gap={2}
                                                >


                                                    {/* Estados */}
                                                    <Grid container xs={12} sx={{ mt: 2}}>
                                                        {/* <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                                            Filtrar por Estado
                                                        </Typography> */}

                                                        <Grid container direction={'row'} xs={12} spacing={2} justifyContent="space-around" alignItems={'center'}>
                                                            {estados.map((estado) => (
                                                                <Grid
                                                                    item
                                                                    key={estado.id}
                                                                    xs={6}
                                                                    sm={4}
                                                                    md={3}
                                                                    xl={2}
                                                                    container
                                                                    direction="row"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                >
                                                                    {estado.nombre}&nbsp;
                                                                    <SquareIcon
                                                                        style={{
                                                                            color: `#${estado.color}`,
                                                                            backgroundColor: `#${estado.color}`,
                                                                            borderRadius: '4px',
                                                                            boxShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
                                                                            marginLeft: 1,
                                                                            marginRight: 1,
                                                                        }}
                                                                    />
                                                                    <Checkbox
                                                                        checked={estado.checked == 1}
                                                                        onChange={() => handleCheckboxChange(estado.id)}
                                                                        inputProps={{ 'aria-label': 'estado-checkbox' }}
                                                                    />
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </Grid>

                                                    {/* Divider visual */}
                                                    {/* <Divider style={{ width: '80%', margin: '20px 0' }} /> */}

                                                    {/* Tipos de Tarea */}
                                                    {/* <Grid item xs={12}>
                                                        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                                            Filtrar por Tipo de Tarea
                                                        </Typography>


                                                        <Grid container spacing={2} justifyContent="center">
                                                            {tiposDeTarea.map((tipoTarea) => (
                                                                <Grid
                                                                    item
                                                                    key={tipoTarea.id}
                                                                    xs={6}
                                                                    sm={4}
                                                                    md={3}
                                                                    xl={2}
                                                                    container
                                                                    direction="row"
                                                                    justifyContent="center"
                                                                    alignItems="center"
                                                                >
                                                                    {tipoTarea.nombre}&nbsp;
                                                                    <CircleIcon
                                                                        style={{
                                                                            color: `${tipoTarea.color}`,
                                                                            marginLeft: 1,
                                                                            marginRight: 1,
                                                                        }}
                                                                    />
                                                                    <Checkbox
                                                                        checked={tipoTarea.checked == 1}
                                                                        onChange={() => handleRoundChange(tipoTarea.id)}
                                                                        inputProps={{ 'aria-label': 'tipo-checkbox' }}
                                                                    />
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                        <Accordion sx={{ width: '100%' }}>
                                                            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">

                                                            </AccordionSummary>
                                                            <AccordionDetails sx={{ width: '100%' }}>
                                                                <Grid item xs={12} container direction="row" justifyContent="center" alignItems="center">
                                                                    <Grid item xs={6}>
                                                                        <Button
                                                                            variant="contained"
                                                                            color='primary'
                                                                            onClick={() => setOpenCrearTipos(true)}
                                                                            startIcon={<AddCircleIcon />}
                                                                            sx={{ mb: 2 }}
                                                                        >
                                                                            Crear Tipo de Tarea
                                                                        </Button>
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <Button
                                                                            variant="contained"
                                                                            color='primary'
                                                                            onClick={() => setOpenEditarTipos(true)}
                                                                            startIcon={<EditIcon />}
                                                                            sx={{ mb: 2 }}
                                                                        >
                                                                            Modo Edicion
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            </AccordionDetails>
                                                        </Accordion>

                                                    </Grid> */}
                                                </Grid>


                                            </AccordionDetails>
                                        </Accordion>
                                        {/* Loader */}
                                        <Grid item xs={12} justifyContent="center" alignItems="center">
                                            {!cargaFiltrados && <CircularProgress size={40} />}
                                        </Grid>
                                    </Grid>

                                </>
                            )}
                            {tareas.length > 0 ? '' : <Error mensaje={'No hay Tareas todavía'} />}


                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="start"
                                xs={12}
                                gap={2}
                            >

                                {currentTareas.map((tarea, index) => (
                                    <Grid container xs={12} sm={5} md={5} xl={2.3} direction="row" justifyContent="center" alignItems="center" fontWeight={700} key={tarea.id} >
                                        <TareaCard tarea={tarea} opciones={opciones} estados={estados} cargarTareas={cargarTareas} opclientes={opclientes} opTrabajadores={opTrabajadores} tiposDeTarea={tiposDeTarea} opcionesTipoTareas={opcionesTipoTareas} />
                                    </Grid>
                                ))}
                            </Grid>
                            {/* ----------------------------------PAGINACIÓN---------------------------------- */}

                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                marginBottom={"3em"}
                                xs={12}
                                sx={{ mt: 5 }}
                            >
                                <Pagination
                                    count={Math.ceil(totalTareas / itemsPerPage)}
                                    page={currentPage}
                                    siblingCount={0}
                                    onChange={handlePageChange}
                                    color="primary"
                                />
                            </Grid>

                        </Grid>

                        <FormCrearTarea open={crearTarea} setOpen={setCrearTarea} opclientes={opclientes} opTrabajadores={opTrabajadores} cargarTareas={cargarTareas} opcionesTipoTareas={opcionesTipoTareas} setOpcionesTipoTareas={setOpcionesTipoTareas} idClientePreselec={idClientePreselec} idProyectoPreselec={idProyectoPreselec} />
                        <FormCrearSA open={crearSA} setOpen={setCrearSA} opclientes={opclientes} opTrabajadores={opTrabajadores} cargarTareas={cargarTareas} />
                        <FormCrearTipoTarea open={openCrearTipos} setOpen={setOpenCrearTipos} cargarEstados={cargarEstados}></FormCrearTipoTarea>
                        <FormEditarTipoTarea open={openEditarTipos} setOpen={setOpenEditarTipos} tiposDeTarea={tiposDeTarea} cargarEstados={cargarEstados} opcionesTipoTareas={opcionesTipoTareas} setOpcionesTipoTareas={setOpcionesTipoTareas}></FormEditarTipoTarea>


                    </div>
                </>
            )
            }
        </div >

    )
}
